module.exports = __webpack_public_path__ + "assets/images/bola_548e1a9ed1687c1adbb7fd9aaa9f7c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/esfera/bola.png
// module id = 202
// module chunks = 0